import React from 'react';
import PropTypes from 'prop-types';

import Spinner from '@components/Spinner';
import GoogleMap from './Map';

function MapLoader({ fullScreen, isGoogleMapLoaded, ...props }) {
  return isGoogleMapLoaded ? (
    <GoogleMap {...props} />
  ) : (
    <Spinner fullScreen={fullScreen} text="Cargando mapa..." />
  );
}

MapLoader.propTypes = {
  isGoogleMapLoaded: PropTypes.bool.isRequired,
  fullScreen: PropTypes.bool,
};

MapLoader.defaultProps = {
  fullScreen: true,
};

export default MapLoader;
